import React from 'react';
import { useParams } from 'react-router-dom';

import { fieldObjectActs } from './auxiliarActs';
import { SubAbasActs, SubAbasActsNovo } from './subabasActs';
import DestaquesComponente from '../../../../components/Destaques';
import { ENTITY } from '../../../../utils/entityNames';

const ActsDestaques: React.FC = () => {
  const params = useParams();
  const fichaID = String(params.id);

  return (
    <DestaquesComponente
      tab="act"
      id_tab={fichaID}
      retorno="/daf/proaq/acts"
      arquivo_export="sisaf_act_destaques.xlsx"
      fieldObject={fieldObjectActs}
      subAbas={fichaID !== 'undefined' ? SubAbasActs(fichaID) : SubAbasActsNovo}
      entity={ENTITY.ENTITY_ACT}
    />
  );
};

export default ActsDestaques;
